"use client";

import { useEffect } from "react";
import { Control, useFormContext } from "react-hook-form";

import FormPhoneField from "@/components/common/forms/FormPhoneField";
import FormTextField from "@/components/common/forms/FormTextField";
import { useAuth } from "@/contexts/AuthContext";
import { FirstStepSchemaType } from "@/schemas/validation/sellCarFormSchema";

interface PersonalInformationStepProps {
  control: Control<FirstStepSchemaType>;
}

const PersonalInformationStep = ({ control }: PersonalInformationStepProps) => {
  const { reset } = useFormContext<FirstStepSchemaType>();
  const { isAuthLoading, isAuthenticated, user } = useAuth();

  useEffect(() => {
    if (isAuthenticated && user) {
      reset({
        name: user.name || "",
        phone: user.phone || "",
      });
    }
  }, [isAuthenticated, user, reset]);

  return (
    <div className="mx-auto max-w-7xl">
      <div className="mt-10">
        <h4 className="mb-4 font-inter text-base font-bold text-primary-foreground">Contact Details</h4>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <FormTextField
            name="name"
            control={control}
            placeholder={isAuthLoading ? "Loading user information..." : "Full Name"}
            required
            disabled={isAuthLoading || isAuthenticated}
          />
          <FormPhoneField
            name="phone"
            control={control}
            placeholder={isAuthLoading ? "Loading user information..." : "Contact Number"}
            required
            disabled={isAuthLoading || isAuthenticated}
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalInformationStep;
